import { useState } from 'react';
import { toast } from 'sonner';
import { useUnlinkCandidate } from './useUnlinkCandidate';

export interface ConfirmUnlinkState {
  open: boolean;
  candidateId: string;
  candidateName: string;
}

export interface UnlinkConfirmation {
  confirmUnlink: ConfirmUnlinkState;
  setConfirmUnlink: (s: ConfirmUnlinkState) => void;
  handleUnlinkClick: (candidateId: string, candidateName: string) => void;
  handleConfirmUnlink: () => void;
  isUnlinking: boolean;
}

export function useUnlinkConfirmation(positionId: string): UnlinkConfirmation {
  const { unlinkCandidate, isLoading: isUnlinking } = useUnlinkCandidate();
  const [confirmUnlink, setConfirmUnlink] = useState<ConfirmUnlinkState>({
    open: false,
    candidateId: '',
    candidateName: '',
  });
  const handleUnlinkClick = (candidateId: string, candidateName: string): void => {
    setConfirmUnlink({ open: true, candidateId, candidateName });
  };
  const handleConfirmUnlink = (): void => {
    unlinkCandidate(
      { positionId, candidateId: confirmUnlink.candidateId },
      {
        onSuccess: () => toast.success('Candidate unlinked successfully'),
        onError: () => toast.error('Failed to unlink candidate'),
      }
    );
  };
  return {
    confirmUnlink,
    setConfirmUnlink,
    handleUnlinkClick,
    handleConfirmUnlink,
    isUnlinking,
  };
}
